// extracted by mini-css-extract-plugin
module.exports = {"itemText":"MembersTableHead_itemText_1SHKR"};